<template>
<div>
   <br>
<div>
  <v-card
    class="mx-auto"
    max-width="1000"
  >

  <v-card height="140" color="blue" >

      <v-row>
          <v-col md="4">

                <img  :src='photoPerfil'  ref='image' style='margin-left:10px;' width='123px' height='123px'>
                 <v-btn style="margin-left:10px;margin-top:-50px;" to="/image-save"   fab dark color="primary">
                    <v-icon dark >add_a_photo</v-icon>
                </v-btn>
          </v-col>
          <v-col style="margin-top:40px;margin-left:70px;font-size:30px;" md="4"><h3 style="color:white;">Meu Perfil</h3></v-col>
      </v-row>

  </v-card>
        <v-card>
    <v-tabs vertical v-model="tab">
      <v-tab>
        <v-icon left>mdi-account</v-icon>
        Perfil
      </v-tab>
      <v-tab>
        <v-icon left>mdi-lock</v-icon>
        Dados de usuário
      </v-tab>

      <v-tab>
        <v-icon left>mdi-lock</v-icon>
           Editar Dados
      </v-tab>
      <v-tab-item>

        <v-card flat>
            <br>
           <div style="background-color:#DEE2E2;text-align:center;color:blue;" >Informações Pessoais</div>

          <v-card-text>
             <v-row>
                 <v-col md="4"><strong>Nome:</strong></v-col>
                <v-col md="8"><strong>{{(usuario.length)?usuario[0].nome:''}}</strong></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Data de Nascimento:</strong></v-col>
                <v-col md="8"><span v-if="getRole !== 'ROLE_EST'">Indisponível</span><span v-if="getRole === 'ROLE_EST'">{{getIdPessoa}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Bi:</strong></v-col>
                <v-col md="8"><span v-if="getRole !== 'ROLE_EST'">{{(usuario.length)?usuario[0].bilhete:''}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Gênero</strong></v-col>
                <v-col md="6"><span v-if="getRole !== 'ROLE_EST'">{{(usuario.length)?usuario[0].sexo:''}}</span><span v-if="getRole === 'ROLE_EST'">{{getIdPessoa}}</span></v-col>
             </v-row>
          </v-card-text>
          <br>
          <hr>
          <v-card-text>
             <v-row>
                 <v-col md="4"><strong>Nome do Pai:</strong></v-col>
                <v-col md="6"><span>{{(usuario.length)?usuario[0].nomepai:''}}</span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Nome da Mãe:</strong></v-col>
                <v-col md="6"><span>{{(usuario.length)?usuario[0].nomemae:''}}</span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Contacto:</strong></v-col>
                <v-col md="6"><span>{{(usuario.length)?usuario[0].contacto:''}}</span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
             <v-row>
                 <v-col md="4"><strong>Status:</strong></v-col>
                <v-col md="8"><span><span>{{(usuario.length)?usuario[0].status_2:''}}</span></span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
           <br>
           <div style="background-color:#DEE2E2;text-align:center" >Dados de usuário</div>
          <v-card-text>
            <v-row>
                 <v-col sm="12" md="6">Nome de usuario:<strong>{{(usuario.length)?usuario[0].username:''}}</strong></v-col>
                <v-col sm="12" md="6">Ultimo vez Activo:<strong>{{(usuario.length)?usuario[0].data_user:''}}</strong></v-col>
             </v-row>
              <v-row>
                 <v-col sm="12" md="6">Role:<strong>{{role}}</strong></v-col>
             </v-row>
          </v-card-text>
          <v-card-action>
            <v-row>
              <v-col col="4"><v-btn color="blue" style="color:white" @click="mudarSenha()" ><v-icon>lock</v-icon>Mudar Senha</v-btn></v-col>
            </v-row>
          </v-card-action>

        </v-card>
      </v-tab-item>

      <v-tab-item>
         <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
        <v-card flat>
            <br>
                      <div   :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>

           <div style="background-color:#DEE2E2;text-align:center;color:blue;" >Edição de dados - Pessoais</div>

          <v-card-text>

             <v-row>
                 <v-col sm="4" md="4">Nome:</v-col>
                <v-col sm="8" md="8">
                  <v-text-field
                       v-model="editedItem.nome"
                       :rules="ruleTextRequired"
                        label="Insira o nome"
                      ></v-text-field>
                </v-col>
             </v-row>
             <v-row>
                 <v-col sm="3" md="4">Bilhete</v-col>
                <v-col sm="9" md="4">
                    <v-text-field
                       v-model="editedItem.bilhete"
                       :rules="ruleBI"
                        v-mask="'#########-AA-###'"
                        label="Insira o número do bilhete"
                      ></v-text-field>
                </v-col>
             </v-row>
          </v-card-text>
          <br>
          <hr>
          <v-card-text>
             <v-row>
                 <v-col sm="3" md="4">Nome do Pai:</v-col>
                <v-col sm="9" md="5">
                     <v-text-field
                        :rules="ruleRequired"
                        v-model="editedItem.nomepai"
                        label="Insira o nome do pai"
                      ></v-text-field>

                </v-col>
             </v-row>
              <v-row>
                 <v-col sm="3" md="4">Nome da Mãe:</v-col>
                  <v-col sm="9" md="5">
                     <v-text-field
                         :rules="ruleRequired"
                        v-model="editedItem.nomemae"
                        label="Insira o nome da mãe"
                      ></v-text-field>

                </v-col>
             </v-row>
              <v-row>
                 <v-col sm="3" md="4">Contacto:</v-col>
                 <v-col sm="9" md="5">
                     <v-text-field
                        :rules="ruleRequired"
                        v-model="editedItem.contacto"
                        label="Contacto"
                      ></v-text-field>

                </v-col>
             </v-row>
             <v-row>
                 <v-col sm="3" md="3"></v-col>
                <v-col sm="5" md="5"><v-btn color="primary" style="color:white;" @click="Actualizar()" :disabled="!valid">Actualizar</v-btn></v-col>
                <v-col sm="4" md="4">
                  <v-progress-circular
                      v-if="progresso"
                      indeterminate
                      color="green"
                  ></v-progress-circular>
                </v-col>
             </v-row>
          </v-card-text>
        </v-card>
         </v-form>
      </v-tab-item>
    </v-tabs>
  </v-card>

  <!--======================================= MODAL==========Mudar Turma-Curso =======================================-->

      <v-dialog
      v-model="dialogo"
      max-width="500"
    >
      <v-card>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
        <v-card-title class="headline"><v-icon color="blue">lock</v-icon>Mudança de Senha</v-card-title>

        <v-card-text>
           <v-row>

               <v-col cols="4">
                    <label> Nome de Usuário:</label>
               </v-col>
                <v-col cols="8">
                    <strong> {{(usuario.length)?usuario[0].nome_pessoa:''}}</strong>
               </v-col>

           </v-row>
           <v-row>

               <v-col cols="7">
                   <v-text-field
                   type='password'
                   :rules="ruleTextRequire"
                   v-model="senha_actual"
                    label="Senha actual"
                  ></v-text-field>
               </v-col>
               <v-col cols="5">
                   <label style="color:red;" v-if="show_senha_errada">Senha incorrecta</label>
               </v-col>
           </v-row>
           <v-row>
              <v-col cols="7">
                <v-text-field
                type= 'password'
                :rules="[rules.required, rules.password_ , rules.password ]"
                v-model="senha_nova"
                label="Nova Senha"
              ></v-text-field>
            </v-col>
           </v-row>
           <v-row>
              <v-col cols="7">
                <v-text-field
                type='password'
                v-model="senha_confirmar"
                label="Confirmar senha"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
                   <label style="color:red;" v-if="error_confirmar" >As senhas não correspondem</label>
               </v-col>
           </v-row>
           <v-row>
              <v-col cols="6"></v-col>
              <v-col cols="6">
                     <v-progress-circular
                      v-if="progresso"
                      indeterminate
                      color="green"
                  ></v-progress-circular>
               </v-col>
               <v-col cols="6" v-if="show_mensagem"><strong style="color:green;">Senha alterada com sucesso</strong></v-col>
           </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialogo = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :disabled="senha_actual === '' || senha_confirmar === '' || senha_nova === '' || !valid"
            @click="ContinuarMudarSenha()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

<!-- ===================================== FIM DO MODAL ================================-->

  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    photoPerfil: ls.get('urlReport') + 'readFileAnywhere/photoPerfil/' + ls.get('username') + '.jpg',
    usuario: [],
    dialogo: false,
    tab:0,
    senha_actual: '',
    idPessoa: ls.get('idPessoa'),
    image: '',
    valid: true,
    bilhete: '',
    hidePassword: true,
    error_confirmar: false,
    show_senha_errada: false,
    progresso: false,
    senha_nova: '',
    nomemae: '',
    nomepai: '',
    genero: '',
    contacto: '',
    show_mensagem: false,
    usuario_encontrado: [],
    senha_confirmar: '',
    senha: false,

    editedItem: {

      Status: '',
      Usuario_username: '',
      autor: null,
      autorizacoes_nome: '',
      bilhete: '',
      chave_confirmacao: null,
      closed: null,
      contacto: '',
      data_2: '',
      data_func: '',
      data_user: null,
      email: '',
      enable: 0,
      fkPessoa: null,
      fkUsuario: 0,
      foto: '',
      idFuncionario: 0,
      idPEssoa: '',
      idinstituicao: 0,
      idperfilFuncionario: 0,
      idusuario_autorizacao: 0,
      info: null,
      infoNumber: null,
      instituicao: 0,
      instituicaoDescricao: '',
      mudarPassword: '',
      nome: '',
      nomeUsuario: '',
      nomemae: '',
      nomepai: '',
      password: '',
      perfilPessoa: null,
      pkUsuario: 0,
      sessionId: null,
      sexo: '',
      sigla: '',
      status_2: null,
      surv: null,
      telefone: '',
      tema: null,
      uploadedFoto: null,
      username: ''

    },

    defaultItem: {

      Status: '',
      Usuario_username: '',
      autor: null,
      autorizacoes_nome: '',
      bilhete: '',
      chave_confirmacao: null,
      closed: null,
      contacto: '',
      data_2: '',
      data_func: '',
      data_user: null,
      email: '',
      enable: 0,
      fkPessoa: null,
      fkUsuario: 0,
      foto: '',
      idFuncionario: 0,
      idPEssoa: '',
      idinstituicao: 0,
      idperfilFuncionario: 0,
      idusuario_autorizacao: 0,
      info: null,
      infoNumber: null,
      instituicao: 0,
      instituicaoDescricao: '',
      mudarPassword: '',
      nome: '',
      nomeUsuario: '',
      nomemae: '',
      nomepai: '',
      password: '',
      perfilPessoa: null,
      pkUsuario: 0,
      sessionId: null,
      sexo: '',
      sigla: '',
      status_2: null,
      surv: null,
      telefone: '',
      tema: null,
      uploadedFoto: null,
      username: ''

    },

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],

    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    rules: {
      required: value => !!value || 'Required.',
      /* sequential123: value => !value.includes('123') || 'A sequência 123 é invalida.',
      sequentialabc: value => !value.includes('abc') || 'A sequência abc é invalida.', */
      password_: value => value.length >= 8 || 'A password deve ter no minimo 8 caracteres',
      password: value => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
        return (
          pattern.test(value) ||

            'A password deve ter ao menos uma letra maiúscula , minuscula e um número.'
        )
      }
    },
    ruleTextRequire: [
      value => !!value || 'campo obrigatório.'
    ],
    sexo: ['Masculino', 'Femenino']
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    getIdPessoa () {
      return ls.get('idPessoa')
    },

    getRole () {
      return ls.get('role')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'SUPER_USER') {
        rl = 'Super Usuário'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.ObterUsuario()
    // this.$refs.src = 'https://softlineangola.com/files/2727-121212121-SA-12121.jpg'
    // this.image = 'https://softlineangola.com/files/' + this.idPessoa + '.jpg'
    this.image = 'http://restrito.esaudeluanda.com/config/IMS/file/5980-foto.jpg'

    if(this.$store.state.tabPerfil === null)
       this.tab = 0
    else
       this.tab = 1
  },
  methods: {

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async ObterUsuario () {
      try {
        this.usuario = await axios
          .get('/PerfilUsuario')
          .then(res => res.data)
        this.editedItem = Object.assign({}, this.usuario[0])
        this.isLoading = false
      } catch (error) {
      }
    },
    mudarSenha () {
      this.dialogo = true
    },

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async ContinuarMudarSenha () {
      if (this.$refs.form.validate()) {
      // Verifica se a senha está correcta
      let dados_1 = {
        password: this.senha_actual
      }

      try {
        this.usuario_encontrado = await axios
          .post('/Verifica-senha/', dados_1)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
      }

      if (this.usuario_encontrado.length) {
        this.show_senha_errada = false

        if (this.senha_nova === this.senha_confirmar) {
          this.progresso = true
          this.error_confirmar = false

          let valor = {

            password: this.senha_nova
          }

          /// Faz a alteraçaõ da senha
          try {
            let msg = await axios
              .post('/altera-senha/', valor)
              .then(res => res.data)
            this.ObterUsuario()
            this.progresso = false
            this.show_mensagem = true
            setTimeout(() => {
              if(this.$store.state.tabPerfil !== null ){this.logout()} // verifica se ele vem do welcome.
              this.dialogo = false
            }, 1000)
            this.Limpar()
          } catch (error) {
            this.progresso = false
          }
        } else { this.error_confirmar = true }
      } else { this.show_senha_errada = true }
      }
    },

    Limpar () {
      this.senha_nova = '',
      this.senha_actual = '',
      this.senha_confirmar = ''
    },

    LimparUpdate (msg) {
      this.bilhete = '',
      this.genero = '',
      this.contacto = '',
      this.nomemae = '',
      this.nomepai = ''
    },

    async Actualizar () {
      this.progresso = true
      const dados =
        {
          nome: this.editedItem.nome,
          bilhete: this.editedItem.bilhete,
          nomepai: this.editedItem.nomepai,
          genero: this.editedItem.sexo,
          nomemae: this.editedItem.nomemae,
          contacto: this.editedItem.contacto
        }

      try {
        let msg = await axios
          .post('/actualizar-funcionario-activo', dados)
          .then(res => res.data)
        this.$store.dispatch('textMessage', { 'msg': 'Dados Pessoais actualizados com sucesso!', 'classMessage': 'msgSucess', 'timeout': 3000 })

        this.progresso = false
        this.LimparUpdate(msg)
        this.ObterUsuario()
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
